import { render, staticRenderFns } from "./WsFullCalendar.vue?vue&type=template&id=5b977b16&"
import script from "./WsFullCalendar.vue?vue&type=script&lang=js&"
export * from "./WsFullCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports